module.exports = __webpack_public_path__ + "static/CNY25_MFKV_mobile-a3f8eaec1f08e904947c04d6fdd9b889.webp";